<template>
  <!-- 添加 报名信息管理-->
  <el-form
    ref="ruleFormRef"
    v-loading="loading"
    :model="ruleForm"
    :rules="rules"
    label-width="110px"
    class="demo-ruleForm scroll_y"
    size="large"
    status-icon
  >
    <el-form-item label="姓名" prop="name">
      <el-input clearable v-model="ruleForm.name" placeholder="请填写姓名" />
    </el-form-item>
    <el-form-item label="手机号" prop="telNumber">
      <el-input
        clearable
        v-model="ruleForm.telNumber"
        placeholder="请填写手机号"
      />
    </el-form-item>
    <el-form-item label="QQ号" prop="qqNumber">
      <el-input
        clearable
        v-model="ruleForm.qqNumber"
        placeholder="请填写QQ号"
      />
    </el-form-item>
    <el-form-item label="学员性别" prop="sex">
      <el-select
        style="width: 300px"
        v-model="ruleForm.sex"
        class="m-2"
        placeholder="请选择学员性别"
        size="large"
      >
        <el-option
          v-for="item in sexList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="预报院校" prop="school">
      <el-input
        clearable
        v-model="ruleForm.school"
        placeholder="请填写预报院校"
      />
    </el-form-item>
    <el-form-item label="预报专业" prop="major">
      <el-input
        clearable
        v-model="ruleForm.major"
        placeholder="请填写预报专业"
      />
    </el-form-item>
    <el-form-item label="报名时Ip地址" prop="ipAddress">
      <el-input
        clearable
        v-model="ruleForm.ipAddress"
        placeholder="请填写报名时Ip地址"
      />
    </el-form-item>
    <el-form-item label="报名来源" prop="source">
      <el-input
        clearable
        v-model="ruleForm.source"
        placeholder="请填写报名来源"
      />
    </el-form-item>
    <el-form-item label="报名状态" prop="status">
      <el-select
        style="width: 300px"
        v-model="ruleForm.status"
        class="m-2"
        placeholder="请选择报名状态"
        size="large"
      >
        <el-option
          v-for="item in statusList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="备注" prop="remarks">
      <el-input
        clearable
        v-model="ruleForm.remarks"
        placeholder="请填写备注"
        :autosize="{ minRows: 2, maxRows: 4 }"
        type="textarea"
      />
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm(ruleFormRef)"
      :disabled = "submitDisabled">提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import { addInfo } from "network/registrationInfo.js";
import {
  getSlideDetail,
  addSlide,
  editSlide,
} from "network/slideManagement.js";
import {
  toRefs,
  reactive,
  ref,
  unref,
  onMounted,
  toRaw,
  computed,
  watch,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
// import ImgUpload from "components/ImgUpload.vue";
import { isHttp, textFilter, isEditorNull } from "common/utils";
import constGlobal from "common/global.js";
export default {
  name: "AddEditRegistration",
  components: {
    // ImgUpload,
  },
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {},
  setup(props, { emit }) {
    const ruleFormRef = ref();

    const data = reactive({
      loading: false,

      ruleForm: {
        name: "",
        telNumber: "",
        qqNumber: "",
        sex: 1,
        school: "",
        major: "",
        remarks: "",
        ipAddress: "",
        source: "",
        identity: 0,
        status: 1,
      },
      rules: {
        name: [{ required: true, message: "请填写姓名" }],
        telNumber: [
          {
            required: true,
            message: "请填写手机号",
          },
        ],
      },
      submitDisabled:false,
    });

    onMounted(() => {});

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled=true;
          updataAdd().then(() => {
            data.submitDisabled = false;
          });;
        }
      } catch (error) {
         ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    function updataAdd() {
      if (data.ruleForm.linkUrl && !isHttp(data.ruleForm.linkUrl)) {
        ElMessage.warning("跳转链接必须使用http或https开头");
        return false;
      }
      data.loading = true;
      addInfo(data.ruleForm)
        .then((result) => {
          if (result && result.code == 1) {
            data.loading = false;
            ElMessageBox.alert(result.message, "添加", {
              confirmButtonText: "确定",
                       });
            emit("close-dialog");
            emit("update-list");
          } else {
            data.loading = false;
            ElMessageBox.alert(result.message, "添加", {
              confirmButtonText: "确定",
                      });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };
    return {
      ...toRefs(data),
      ruleFormRef,
      submitForm,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 450px;
}

>>> .el-form-item--large .el-form-item__content {
  line-height: 20px !important;
}
</style>

